import React from 'react';
import './dashboard-tab.scss';
import { user_navigator } from '../../../../assets/image.assets';
import { useIntl } from 'react-intl';

const TournamentDashboardTab = ({ tourTabIndex, dashboardTab }) => {
    const intl = useIntl();
    return (
        <div className="dashboard-tab">
            <div
                className={`leaderboard-tab ${
                    tourTabIndex === 0 ? ' active' : ''
                }`}
                onClick={() => dashboardTab(0)}
            >
                <span
                    className={`tab-text ${
                        tourTabIndex === 0 ? ' active-text' : ''
                    }`}
                >
                    {intl.messages.tournament.leaderBoard}
                </span>
            </div>
            <div
                className={`leaderboard-tab ${
                    tourTabIndex === 1 ? ' active' : ''
                }`}
                onClick={() => dashboardTab(1)}
            >
                <span
                    className={`tab-text ${
                        tourTabIndex === 1 ? ' active-text' : ''
                    }`}
                >
                    {intl.messages.tournament.followed}
                </span>
            </div>
            <div className="dashboard-tab-img">
                <img src={user_navigator} alt="#" />
            </div>
        </div>
    );
};
export default TournamentDashboardTab;
